var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_22213",
    "data-name": "\\uADF8\\uB8F9 22213",
    transform: "translate(-1553 -1179)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28425",
    "data-name": "\\uC0AC\\uAC01\\uD615 28425",
    width: 24,
    height: 24,
    transform: "translate(1553 1179)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "twitter-original",
    d: "M6.886,22.094a11.013,11.013,0,0,0,11.1-11.1,3.325,3.325,0,0,0-.03-.518A8.155,8.155,0,0,0,19.91,8.46a7.344,7.344,0,0,1-2.226.61A3.776,3.776,0,0,0,19.391,6.9a8.185,8.185,0,0,1-2.5.945A3.9,3.9,0,0,0,14.054,6.6a3.944,3.944,0,0,0-3.934,3.934,4.655,4.655,0,0,0,.091.915A11.418,11.418,0,0,1,2.25,7.332a3.975,3.975,0,0,0-.518,1.952A3.832,3.832,0,0,0,3.5,12.517a4.242,4.242,0,0,1-1.769-.488v.031A3.954,3.954,0,0,0,4.843,15.9a3.879,3.879,0,0,1-.976.122,2.831,2.831,0,0,1-.732-.091,3.942,3.942,0,0,0,3.66,2.714,7.892,7.892,0,0,1-4.819,1.677A3.415,3.415,0,0,1,1,20.294a10.186,10.186,0,0,0,5.886,1.8",
    transform: "translate(1554.547 1177.32)",
    fill: "#212529"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon2);
export default __webpack_public_path__ + "static/media/FooterIcon2.34fb818002a6f4ffd49d3b96a94b068e.svg";
export { ForwardRef as ReactComponent };